import { Image } from "@mantine/core";

import type { Screening } from "@/types/screeners";
import { PropsWithTableInfo } from "@/types/third-party";

export const CreatedAtCell = <TData,>({
  info,
}: PropsWithTableInfo<TData, string>) => {
  const isPartialSessionStatus =
    // Even though we don't know this is a screening, casting is safe here as we want this to return false for
    // screener locations regardless.
    (info.row.original as Screening)?.sessionStatus === "partial";
  const cellValue = info.getValue();

  return (
    <div
      className={`w-full flex gap-2 justify-start items-center ${
        isPartialSessionStatus ? "text-red-600" : ""
      }`}
    >
      {cellValue
        ? new Date(cellValue).toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })
        : "—"}
      {isPartialSessionStatus && (
        <Image
          alt="This session is incomplete/partial"
          src="/assets/red-x.svg"
        />
      )}
    </div>
  );
};
